module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point1_2-d896cef4f39024efbf8f5487b339cc4e.jpg";